import { connect } from 'react-redux';
import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { createActions } from '../../store';
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';

class UndoActionButton extends React.Component {

    render() {
        const { pastHistoryItemsLength, undo, savingInProgress, showCriticalOperationProgressWarning } = this.props;

        const onClick = () => {
            if (savingInProgress) {
                showCriticalOperationProgressWarning();
                return;
            }
            undo();
        };

        return (
            <Tooltip 
                title='Undo' 
                arrow 
                placement='bottom'
            >
                <div>
                    <IconButton
                        onClick={onClick}
                        disabled={!pastHistoryItemsLength}
                        aria-label='Undo'
                        size="large">
                        <UndoRoundedIcon />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}

const mapStateToProps = (state) => {
    const { length: pastHistoryItemsLength } = state.createPreview.past;
    const { savingInProgress } = state.create.videoSavingState;

    return { pastHistoryItemsLength, savingInProgress }
}

const mapDispatchToProps = (dispatch) => {
    const undo = () => dispatch(createActions.undo());
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return {
        undo,
        showCriticalOperationProgressWarning
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UndoActionButton);